import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import Config from '../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import SalePackages from '../SalePackagesBlock/SalePackages';
import BtnWhiteBlackBorderBigSize from '../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import FamilyStatus from '../../Shared/FamilyStatus/FamilyStatus';
import FamilyMemberCellularSaleError from './FamilyMemberCellularSaleError';
import ProviderManager from '../../../provider/providerManager';
import {isMobile} from 'react-device-detect';
import {checkIfBackFromLogin, resetBlock} from '../SaleBlock/saleBlockSlice';
import {getOrganizationFamilyPackagesData} from '../WelcomeBlock/welcomeBlockSlice';
import OrgFamilyMembersSale from './OrganizationFamilyMembersSale/OrgFamilyMembersSale';
import {GetOrganizationDataFromEpi,setLoadingPackagesAfterML} from './familyMemberCellularSaleSlice';
import FamilyMemberCellularSalePackages from './FamilyMemberCellularPackages/FamilyMemberCellularSalePackages';
import ProgressBar from '../../Shared/ProgressBar/progressBar';
import {orgFamilyMembersSalePages, PROGRAM_STEPS} from './OrganizationFamilyMembersSale/enums';
import SuccessOrErrorScreen from './OrganizationFamilyMembersSale/successOrErrorScreen/SuccessOrErrorScreen';
import hey from './OrganizationFamilyMembersSale/images/hey.svg';

const FamilyMemberCellularSaleMain = (props) => {
  const checkIfRelevantRoleExist = (roles) => {
    const relevantRoles = [
      'CREDENTIALS_CELLCOM_WEB_SITE_SALEFAMILYNPQ',
      'CREDENTIALS_CELLCOM_WEB_SITE_CHANGEFAMILYPP',
      'CREDENTIALS_CELLCOM_WEB_SITE_CHANGEFAMILYPRIMARYPP',
    ];
    return relevantRoles.some((role) => roles?.includes(role));
  };
  const soldierFromLoginIdf = (roles) => {
    return roles?.includes('IDFOTP_CUSTOMEREXIST');
  };
  const checkIfIsOrgFamilyMembersSaleProcess = (isRelevantRoleExist, roles) => {
    if (soldierFromLoginIdf(roles) && !props.completed) {
      return true;
    }
    if (isRelevantRoleExist || props.completed || !props.magicLinkIndication) {
      return false;
    }
    return true;
  };
  const roles = props.authenticationStore?.loginData?.userDetails?.RoleList;
  const isRelevantRoleExist=checkIfRelevantRoleExist(roles);
  const familyPackagesData = isRelevantRoleExist?{...props.welcomeBlock?.familyPackagesData,isAllowed:true}:props.welcomeBlock?.familyPackagesData;
  const isOrgFamilyMembersSaleProcess = checkIfIsOrgFamilyMembersSaleProcess(isRelevantRoleExist,roles);
  const familyCellularPackageList = props.authenticationStore?.loginData?.magicLinkParameters ? props.store.organizationCellularPackages : props.cellularPackageList;
  props.resetBlock();


 const getPendingStatus=()=>{
  if(!isRelevantRoleExist){
    if(props.store.loadingPackagesAfterML){
      props.setLoadingPackagesAfterML(false);
    }
    return true;
  }
  else{
    if(props.store.loadingPackagesAfterML){
      props.showAppLoader();
      return false;
    }
    props.hideAppLoader();
    return true;
  }
 }

  useEffect(()=>{
    props.hideAppLoader();
  },[props.store.programCurrentStep])

  useEffect(() => {
    const getOrganizationFamilyPackagesDataAsync = async () => {
      props.showAppLoader();
      await props.getOrganizationFamilyPackagesData();
      props.hideAppLoader();
    };
    if(!isRelevantRoleExist){
      getOrganizationFamilyPackagesDataAsync();
    }
  }, []);

  useEffect(() => {
    const getOrgMagicLink = async (subscriberOrgId) => {
      props.showAppLoader();
      await props.GetOrganizationDataFromEpi(subscriberOrgId);
      props.hideAppLoader();
    };
    const subscriberOrgId=props.authenticationStore?.loginData?.magicLinkParameters?.orgNumber;
    if(subscriberOrgId!==undefined && subscriberOrgId!==null && subscriberOrgId!=="" && isRelevantRoleExist){
      getOrgMagicLink(subscriberOrgId);
    }
  }, [props.authenticationStore?.loginData?.magicLinkParameters?.orgNumber]);

  return (
    <>
        {getPendingStatus() && <div className='family-member-cell-sale'>
          {familyPackagesData && !familyPackagesData.isAllowed && (
            <div className='family-member-cell-sale-error'>
              {!familyCellularPackageList ? (
                <FamilyMemberCellularSaleError title={'מצטערים, פעולה זו לא אפשרית'} />
              ) : (
                <FamilyMemberCellularSaleError
                  title={`מימשת ${familyPackagesData?.used ?? "0"}/${familyPackagesData?.capacity ?? "0"} הטבות לחבילות מיוחדות לבני משפחת ${props.orgName}`}
                  subtitle={`לקבלת מידע נוסף ועזרה יש לפנות לאיש הקשר`}
                />
              )}
            </div>
          )}
          {familyPackagesData && familyPackagesData.isAllowed && (
            <>
              {!familyCellularPackageList?.value ? (
                <SuccessOrErrorScreen
                  popUpObj={{
                    icon: hey,
                    heading: 'מצטערים, משהו השתבש בתהליך ולא ניתן לבצע את הפעולה שביקשת',
                    secondaryHeading: 'נציגנו ישמחו לסייע לך',
                    whiteBlackBtn: {
                      text: 'לפרטים ומידע נוסף התקשרו ל-2759*',
                    },
                    buttonText: 'חזרה לאיזור האישי',
                    btnClickedCallBack: () => {
                      EpiContext.navigateTo(Config.lobbyUrl);
                    },
                  }}
                />
              ) : (
                <>
                  {!isOrgFamilyMembersSaleProcess ? (
                    <>
                      {!props.completed && (
                        <ProgressBar points={[]} percent={orgFamilyMembersSalePages[PROGRAM_STEPS.SHOW_CELLULAR_PACKAGES] ?? '0'} />
                      )}
                      <FamilyMemberCellularSalePackages context={props.context} cellularPackageList={familyCellularPackageList} />
                    </>
                  ) : (
                    <OrgFamilyMembersSale
                      customerName={props.orgName}
                      context={props.context}
                      iContent={props.iContent}
                    />
                  )}
                </>
              )}
            </>
          )}
        </div>}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    cellularPackageList: state.selfcarePage.organizationState?.cellularPackageList,
    magicLinkIndication:state.selfcarePage.organizationState?.canSendThirdPartyLink?.value,
    orgName:state.selfcarePage.organizationState?.name,
    welcomeBlock: state.welcomeBlock,
    store: state.familyMemberCellularSale,
    authenticationStore: state.authentication,
  };
};

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
  resetBlock,
  getOrganizationFamilyPackagesData,
  GetOrganizationDataFromEpi,
  setLoadingPackagesAfterML,
};
export default connect(mapStateToProps, mapDispatchToProps)(FamilyMemberCellularSaleMain);
